import Flag from '../../src/legacy/Flag.tsx';
export default Flag;
